import classNames from 'classnames';
import React, { ReactNode } from 'react';

import { ColorConfig } from '@/contexts/AntdConfigProvider/theme';

import { Typography, Link, Icon, ConditionView } from '../';
import { IconName } from '../Icon/icons';

import './Informer.scss';

export interface InformerProps {
  id?: string;
  className?: string;
  icon?: { name: IconName; color?: ColorConfig };
  header?: { text: ReactNode; color?: ColorConfig; textCenter?: boolean };
  text?: { text: ReactNode; color?: ColorConfig; textCenter?: boolean; semibold?: boolean };
  bgColor?: 'sand' | 'white' | 'sky-blue';
  borderColor?: 'black' | 'dark-yellow' | 'blue' | 'red' | 'none';
  link?: string;
  linkText?: string;
  onLinkClick?: () => void;
}

export const Informer: React.FC<InformerProps> = ({
  className,
  icon,
  header = { text: '', color: 'black', textCenter: false },
  text = { text: '', color: 'black', textCenter: false, semibold: true },
  link,
  bgColor = 'sand',
  borderColor = 'dark-yellow',
  linkText = 'Детальніше',
  onLinkClick,
}) => (
  <div
    data-testid="informer"
    style={{
      backgroundColor: `var(--${bgColor})`,
      borderColor: borderColor === 'none' ? 'transparent' : `var(--${borderColor})`,
    }}
    className={classNames('custom-informer', className)}
  >
    {icon && (
      <div data-testid="informer-icon" className="custom-informer__icon">
        <Icon name={icon.name} color={icon.color} />
      </div>
    )}

    <div className="custom-informer__text-block">
      <ConditionView if={Boolean(header.text)}>
        <Typography
          data-testid="informer-header"
          as="span"
          color={header.color}
          textCenter={header.textCenter}
          className="text-block__header"
        >
          {header.text}
        </Typography>
      </ConditionView>

      <ConditionView if={Boolean(text.text)}>
        <Typography
          data-testid="custom-informer-text"
          as="span"
          variant="TEXT14"
          color={text.color}
          textCenter={text.textCenter}
          semibold={text.semibold ?? true}
          className="text-block__body"
        >
          {text.text}
        </Typography>
      </ConditionView>
      {(onLinkClick || link) && (
        <Link data-testid="custom-informer-link" to={link ?? ''} onClick={onLinkClick}>
          {linkText}
        </Link>
      )}
    </div>
  </div>
);
